// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/user';
const ADMIN_DASHBOARD = '/admin';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const ADMIN_PATH_DASHBOARD = {
  root: ADMIN_DASHBOARD,
  general: {
    createQuestionMultichoiceTranslation: path(ADMIN_DASHBOARD, '/create-question/multichoice/translation'),
    createQuestionBasicTranslation: path(ADMIN_DASHBOARD, '/create-question/basic/translation'),
    createQuestionMultichoiceAnnotation: path(ADMIN_DASHBOARD, '/create-question/multichoice/annotation'),
    createTranscriptionQuestion: path(ADMIN_DASHBOARD, '/create-question/transcription'),
    createVCValidatorQuestion: path(ADMIN_DASHBOARD, '/create-question/vc-validator'),
    createLanguageParagraphQuestion: path(ADMIN_DASHBOARD, '/create-question/language-skills/paragraph'),
    createLanguageParallelQuestion: path(ADMIN_DASHBOARD, '/create-question/language-skills/parallel'),
    createLanguageImprovementQuestion: path(ADMIN_DASHBOARD, '/create-question/language-skills/improvement'),
    createLanguageSummaryQuestion: path(ADMIN_DASHBOARD, '/create-question/language-skills/summary'),
    createLanguageSummaryCThinking: path(ADMIN_DASHBOARD, '/create-question/language-skills/cthinking'),
    createLanguageReading: path(ADMIN_DASHBOARD, '/create-question/language-skills/reading'),
    createTranscriptionTest: path(ADMIN_DASHBOARD, '/create-test/transcription'),
    createAnnotationTest: path(ADMIN_DASHBOARD, '/create-test/annotation'),
    createYesnoTest: path(ADMIN_DASHBOARD, '/create-test/yesno'),
    createTranslationTest: path(ADMIN_DASHBOARD, '/create-test/translation'),
    createLanguageTest: path(ADMIN_DASHBOARD, '/create-test/language'),
    listLanguageSkillsResults: path(ADMIN_DASHBOARD, '/list-language-skills-results'),
    createAdminSettings: path(ADMIN_DASHBOARD, '/admin-settings'),
    createQuestionYesNo: path(ADMIN_DASHBOARD, '/create-question/yes-no'),
    createTest: path(ADMIN_DASHBOARD, '/create-test'),
    createVoiceCollectionTask: path(ADMIN_DASHBOARD, '/create-voice-collection/task'),
    createVoiceCollectionValidatorTest: path(ADMIN_DASHBOARD, '/create-voice-collection-validator-test'),
    createVoiceCollectionForm: path(ADMIN_DASHBOARD, '/create-voice-collection/form'),
    myTests: path(ADMIN_DASHBOARD, '/my-tests'),
    browseTests: path(ADMIN_DASHBOARD, '/browse-tests'),
    browseQuestions: path(ADMIN_DASHBOARD, '/browse-questions'),
    evaluateLanguageTests: path(ADMIN_DASHBOARD, '/evaluate-language-test'),
    voiceCollectionEvaluationResults: path(ADMIN_DASHBOARD, '/voice-collection-evaluation-results'),
    voiceCollectionEvaluation: path(ADMIN_DASHBOARD, '/voice-collection-evaluation'),
    browseVoiceCollectionForms: path(ADMIN_DASHBOARD, '/browse-voice-collection-forms'),
    browseVoiceCollectionFormEvaluations: path(ADMIN_DASHBOARD, '/browse-voice-collection-form-evaluations'),
    browseCreativitySkillsTest: path(ADMIN_DASHBOARD, '/browse-creativity-skills-test'),
    browseVoiceCollectionTasks: path(ADMIN_DASHBOARD, '/browse-voice-collection-tasks'),
    account: path(ADMIN_DASHBOARD, '/account'),
    uploadExcel: path(ADMIN_DASHBOARD, '/upload-excel'),
    createJobType: path(ADMIN_DASHBOARD, '/create-job-type'),
    jobTypeList: path(ADMIN_DASHBOARD, '/job-type-list'),
    blockUserList: path(ADMIN_DASHBOARD, '/block-users'),
    userList: path(ADMIN_DASHBOARD, '/user-list'),
    authSettings: path(ADMIN_DASHBOARD, '/auth-settings'),
    addRemoveDomains: path(ADMIN_DASHBOARD, '/add-remove-domains'),
  },
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
    myTestResults: path(ROOTS_DASHBOARD, '/my-test-results'),
    testToDo: path(ROOTS_DASHBOARD, '/tests-to-do'),
    certification: path(ROOTS_DASHBOARD, '/certification'),
    termsLegal: path(ROOTS_DASHBOARD, '/terms-legal'),
    browseTest: path(ROOTS_DASHBOARD, '/browse-test'),
    jobList: path(ROOTS_DASHBOARD, '/job-list'),
    takeTest: path(ROOTS_DASHBOARD, '/take-test'),
    myQualifications: path(ROOTS_DASHBOARD, '/my-qualifications'),
    voiceCollection: path(ROOTS_DASHBOARD, '/voice-collection-form'),
    validatorTakeTest: path(ROOTS_DASHBOARD, '/validator-take-test'),
    browseVoiceCollectionFormEvaluations: path(ROOTS_DASHBOARD, '/browse-voice-collection-form-evaluations'),
    voiceCollectionEvaluation: path(ROOTS_DASHBOARD, '/voice-collection-evaluation'),
    browseCreativitySkillsTest: path(ROOTS_DASHBOARD, '/browse-creativity-skills-test'),
    evaluateLanguageTests: path(ROOTS_DASHBOARD, '/evaluate-language-test'),
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    view: (name) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    new: path(ROOTS_DASHBOARD, '/user/new'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    edit: (name) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    new: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    view: (name) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}`),
    edit: (name) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    demoView: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
  },
  invoice: {
    root: path(ROOTS_DASHBOARD, '/invoice'),
    list: path(ROOTS_DASHBOARD, '/invoice/list'),
    new: path(ROOTS_DASHBOARD, '/invoice/new'),
    view: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit'),
    demoView: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5'),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    new: path(ROOTS_DASHBOARD, '/blog/new'),
    view: (title) => path(ROOTS_DASHBOARD, `/blog/post/${title}`),
    demoView: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
  },
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
